import { ErrorAlert, ErrorAlertVariants } from '@venienergygroup/shared-components';
import { useTranslations } from 'next-intl';
import { FC } from 'react';

type LocalizedAlertVariant = 'error' | 'noResults';

const LOCALIZED_VARIANT_MAP: Record<ErrorAlertVariants, LocalizedAlertVariant> = {
  error:     'error',
  noResults: 'noResults',
  info:      'noResults',
  warning:   'noResults',
};

export const ErrorAlertLocalized: FC<{ variant: ErrorAlertVariants; className?: string }> = ({ variant, ...rest }) => {
  const localizedVariant = LOCALIZED_VARIANT_MAP[variant];
  const t = useTranslations(`Error.alert.${localizedVariant}`);
  return (
    <ErrorAlert title={t('title')} variant={variant} {...rest}>
      {t('description')}
    </ErrorAlert>
  );
};